class QuickFilter {

	constructor() {
    let quickFilter = document.getElementById('quick-filter');

    if (quickFilter) {

      quickFilter.addEventListener('submit', (e) => {
        sessionStorage.setItem('destination_category[]', document.getElementById('destination_category').value);
        sessionStorage.setItem('destination_location[]', document.getElementById('destination_location').value);
      });
    }
  }
}

export default QuickFilter;
